export default {
  client: {
    create: (options) => {
      if (options?.authorization === 'bt_client_token') return Promise.resolve({})

      alert('Braintree authorization is incorrect')
      return Promise.reject({})
    },
  },
  applePay: {
    create: (options) => {
      if (!options?.client) {
        alert('Braintree client is missing')
        return Promise.reject({})
      }

      return Promise.resolve({
        tokenize: (options) => {
          if (!options?.token?.transactionIdentifier) {
            alert('Braintree apple-pay transaction identifier is missing')
            return Promise.reject({})
          }
          return Promise.resolve({ nonce: '584dbfbe-2eb7-1758-7001-7c81eca2e59b' })
        },
      })
    },
  },
  paypalCheckout: {
    isSupported: () => true,
    create: (config) => {
      return new Promise((resolve, reject) => {
        if (config && config.client) {
          resolve({
            tokenizePayment: (data) => {
              return new Promise((resolve, reject) => {
                const payerID = 'E6JHAK4N39DP8'
                const paymentID = '53K59297RS621042L'

                if (!data || data.payerID !== payerID || data.paymentID !== paymentID) {
                  return reject(new Error('Invalid payment'))
                }

                resolve({
                  nonce: 'fake-nonce',
                  details: {
                    email: 'customer@personal.example.com',
                    firstName: 'John',
                    lastName: 'Doe',
                    payerId: payerID,
                    countryCode: 'US',
                    billingAddress: {
                      countryCode: 'US',
                    },
                    shippingAddress: {
                      line1: '123 Main St',
                      line2: 'Apt 4B',
                      city: 'San Francisco',
                      state: 'CA',
                      postalCode: '94105',
                      countryCode: 'US',
                    },
                  },
                  type: 'PayPalAccount',
                })
              })
            },
          })
        } else {
          reject(new Error('Invalid config'))
        }
      })
    },
  },
}
